var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealEstate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230.67 247.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:13px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "224.17 120.89 196.92 120.89 196.92 240.85 33.75 240.85 33.75 120.89 6.5 120.89 40.21 85.46 64.21 60.23 115.33 6.5 167.91 61.76 191.91 86.98 224.17 120.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.21,
    y1: 240.85,
    x2: 220.46,
    y2: 240.85
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "191.91 36.8 191.91 86.98 167.91 61.76 167.91 36.8 191.91 36.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.1,
    y: 166.31,
    width: 34.46,
    height: 74.54
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstate);
export default __webpack_public_path__ + "static/media/realEstate.3d4022704e9609876069721afd709d86.svg";
export { ForwardRef as ReactComponent };